import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { initialState } from '../../../data/userSetup/adminScreenRole/initialState.adminScreenRole.data';
import { ADMIN_SCREEN_ROLE } from '../../../constants/actionCreator';
import { fetchRoles as fetchRolesAPI } from '../../../apis/adminScreenRoleAPI';
import { fetchPermissionRole as fetchPermissionRoleAPI } from '../../../apis/adminScreenRoleAPI';
import { setRolePermission as setPermissionRoleAPI } from '../../../apis/adminScreenRoleAPI';
import { loginWithToken as loginWithTokenAPI } from '../../../apis/adminScreenRoleAPI';

export const fetchRoles = createAsyncThunkWrapper(
  ADMIN_SCREEN_ROLE.ROLES,
  fetchRolesAPI
);

export const fetchPermissionRole = createAsyncThunkWrapper(
  ADMIN_SCREEN_ROLE.GETPERMISSIONROLE,
  fetchPermissionRoleAPI
);

export const setPermissionRole = createAsyncThunkWrapper(
  ADMIN_SCREEN_ROLE.SETPERMISSIONROLE,
  setPermissionRoleAPI
);

export const loginWithToken = createAsyncThunkWrapper(
  ADMIN_SCREEN_ROLE.loginWithToken,
  loginWithTokenAPI
);
const AdminScreenRoleSlice = createSlice({
  name: 'AdminScreenRole',
  initialState,
  reducers: {
    setResponse: (state, action) => {
      state.saveResponse = action?.payload;
    },
    resetAdmin:(state)=>{
      state.reset=initialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.rolesLoading = true;
        state.rolesData = [];
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.rolesLoading = false;
        state.rolesData = action?.payload || [];
      })
      .addCase(fetchRoles.rejected, (state) => {
        state.rolesLoading = false;
        state.rolesData = [];
      })
      .addCase(fetchPermissionRole.pending, (state) => {
        state.loadingSave = true;
        state.getRolePermissionData = [];
      })
      .addCase(fetchPermissionRole.fulfilled, (state, action) => {
        state.loadingSave = false;
        state.getRolePermissionData = action?.payload || [];
      })
      .addCase(fetchPermissionRole.rejected, (state, action) => {
        state.loadingSave = false;
        state.getRolePermissionData = action?.payload;
      })

      .addCase(setPermissionRole.pending, (state) => {
        state.saveLoading = true;
        state.saveResponse = null;
      })
      .addCase(setPermissionRole.fulfilled, (state) => {
        state.saveLoading = false;
        state.saveResponse = true;
      })
      .addCase(setPermissionRole.rejected, (state) => {
        state.saveLoading = false;
        state.saveResponse = false;
      })

      .addCase(loginWithToken.pending, (state) => {
        state.tokenLoginData = [];
      })
      .addCase(loginWithToken.fulfilled, (state, action) => {
        state.tokenLoginData = action?.payload ? action?.payload : [];
      })
      .addCase(loginWithToken.rejected, (state) => {
        state.tokenLoginData = [];
      });
  },
});

export const { setResponse ,resetAdmin} = AdminScreenRoleSlice.actions;
export default AdminScreenRoleSlice.reducer;
